import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  img: {
    display: 'block',
    width: 124,
    height: 30,
    objectFit: 'contain',
    objectPosition: 'left center',
  },
});

const LogoFull = () => {
  const classes = useStyles();

  return <img className={classes.img} src="va-logo.png" alt="VA" />;
};

export default LogoFull;
